/**
 * M3X.WORKSPACE-CLOSURE Session 2 PR 5 — pin-limit toast.
 *
 * Slides up from the bottom-right when the user tries to pin a
 * 6th sub-domain. Auto-dismisses after 5s; manual dismiss button.
 * Colors locked by closure-prompt §5: bg #fef3c7, text #78350f,
 * border #fcd34d.
 *
 * Bilingual via i18n key workspace.rail2.pinLimit.toast.
 */

import { X } from "lucide-react";
import { useTranslation } from "react-i18next";


export interface PinLimitToastProps {
  show: boolean;
  onDismiss: () => void;
}


export function PinLimitToast({ show, onDismiss }: PinLimitToastProps) {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-pin-limit-toast
      className="fixed bottom-6 end-6 z-50 flex max-w-[320px] items-start gap-3"
      style={{
        backgroundColor: "#fef3c7",
        color: "#78350f",
        border: "1px solid #fcd34d",
        borderRadius: "8px",
        padding: "12px 16px",
        fontSize: "13px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
      }}
    >
      <span className="flex-1">
        {t(
          "workspace.rail2.pinLimit.toast",
          "Pin limit reached — unpin one first",
        )}
      </span>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        className="-mt-0.5 rounded p-0.5 hover:bg-amber-100"
        style={{ color: "#78350f" }}
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}


export default PinLimitToast;
